import { MainApi } from './MainApi';
import { xVerifyApi } from './xVerifyApi';

export { MainApi, xVerifyApi };
